export const GET_ITINERARY_CLOSURE_REASONS = 'GET_ITINERARY_CLOSURE_REASONS';
export const CLEAR_ITINERARY_CLOSURE_REASONS =
  'CLEAR_ITINERARY_CLOSURE_REASONS';
export const FLAG_GETTING_ITINERARY_CLOSURE_REASONS =
  'FLAG_GETTING_ITINERARY_CLOSURE_REASONS';
export const FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY =
  'FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY';
export const GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE =
  'GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE';
export const CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE =
  'CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE';
